<!-- 新闻媒体 -->
<template>
	<div>
		<ul class="panel-list">
			<li class="panel-item" :class="{ active: active === item.page }" v-for="(item, index) in panelList"
				:key="index" @click="handlePanelCheck(item)">
				<i class="iconfont" :class="item.icon" style="font-size: 20px"></i>
				{{ item.label }}
			</li>
		</ul>
		<!--移动端适配-->
		<ul class="panel-list-mobile">
			<li class="panel-item" :class="{ active: active === item.page }" v-for="(item, index) in panelList"
				:key="index" @click="handlePanelCheck(item)">
				<i class="iconfont" :class="item.icon" style="font-size: 20px"></i>
				{{ item.label }}
			</li>
		</ul>
		<div class="container" ref="component" v-show="!showDetail">
			<div class="circle" title="回到顶部" @click="pageToTop(true)" v-show="showTop">
				<i class="icon el-icon-arrow-up"></i>
			</div>

			<div class="content">
				<component @checkDetail="handleCheck" :is="active"></component>
			</div>
		</div>
		<InfoDetail @returnPage="handleReturn" ref="infoDetail" v-show="showDetail" />
	</div>
</template>

<script>
	import groupHonor from './groupHonor/groupHonor';
	import enterpriseInfo from './enterpriseInfo/enterpriseInfo';
	import industryInfo from './industryInfo/industryInfo';
	import enterpriseCulture from './enterpriseCulture/enterpriseCulture';

	import InfoDetail from "@/views/newsMedia/infoDetail";

	export default {
		components: {
			groupHonor,
			enterpriseInfo,
			industryInfo,
			enterpriseCulture,
			InfoDetail
		},
		name: 'newsMedia',
		data() {
			return {
				currEl: null,
				showDetail: false,
				showTop: false,
				active: 'groupHonor',
				panelList: [{
						label: '企业荣誉',
						icon: 'iconfontjituanrongyu',
						page: 'groupHonor'
					},
					{
						label: '企业资讯',
						icon: 'iconfontqiyezixun',
						page: 'enterpriseInfo'
					},
					{
						label: '行业资讯',
						icon: 'iconfonthangyezixun',
						page: 'industryInfo'
					},
					{
						label: '企业文化',
						icon: 'iconfontqiyewenhua',
						page: 'enterpriseCulture'
					},
				],
				timer: null,
			};
		},
		//刷新或通过URL地址进入页面时，同步背景图和标题
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.$nextTick(() => {
					vm.$bus.$emit('changePageTitleAndBackground', {
						page: 'newsMedia'
					});
				});
			});
		},
		mounted() {

			document.querySelector('#app').addEventListener('scroll', this.isShowTopButton);
		},
		beforeDestroy() {
			document.querySelector('#app').removeEventListener('scroll', this.isShowTopButton);
		},
		methods: {
			//查看详情
			handleCheck(page) {
				if (page) {
					window.open(page)
				}
			},

			handleReturn() {
				this.showDetail = false;
				this.$nextTick(() => {
					console.log(this.currEl);
					document.querySelector(`[data-flag=${this.currEl}]`).scrollIntoView({
						behavior: 'smooth',
						block: 'center'
					});
				});
			},

			//列表类型选择
			handlePanelCheck(item) {
				this.active = item.page;
				this.pageToTop(true);
			},
			//回到顶部按钮显示控制
			isShowTopButton() {
				clearTimeout(this.timer);
				this.timer = setTimeout(() => {
					let el = this.$refs.component;
					if (el) {
						let {
							top
						} = el.getBoundingClientRect();
						this.showTop = top < -400;
					}
				}, 200);
			},
			//滚动到顶部
			pageToTop(isSmooth = false) {
				document.querySelector('.header-bg').scrollIntoView({
					behavior: isSmooth ? 'smooth' : undefined,
					block: 'start'
				});
			},

		},
	};
</script>

<style lang='scss' scoped>
	.panel-list-mobile {
		display: none;
	}

	.panel-list {
		width: 100%;
		display: flex;
		justify-content: space-between;
		transform: translateY(-100%);
		color: #ffffff;
		background: rgba(0, 0, 0, 0.5);
		padding: 0 20%;
		box-sizing: border-box;

		.panel-item {
			cursor: pointer;
			width: 126px;
			height: 50px;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.active {
			background: #1890ff;
		}
	}

	.container {
		height: 100%;
		background: #ffffff;
		//transform: translateY(0);



		.circle {
			cursor: pointer;
			position: fixed;
			border-radius: 50%;
			box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
			padding: 13px;
			color: #409eff;
			margin-top: 64px;
			right: 64px;

			background-color: #ffffff;

			&:hover {
				background-color: #f2f6fc;
			}

			.icon {
				font-size: 24px;
			}
		}

		.content {
			width: 1200px;
			height: 100%;
			margin: 0 auto;
			padding-top: 100px;
		}
	}

	@import "./style.scss";
</style>